export default __webpack_public_path__ + "assets/models/6409f6fbeb96155ced4bb1b85353d770.glb";